const Locales: Record<string, string> = {
    AU: "en-US",
    CN: "en-US",
    JP: "ja-JP",
    TH: "en-US",
    IN: "en-US",
    MY: "en-US",
    KR: "ko-KR",
    HK: "zh-TW",
    TW: "zh-TW",
    PH: "en-US",
    VN: "en-US",
    FR: "fr-FR",
    US: "en-US",
    GB: "en-US",
    DE: "de-DE",
    CH: "fr-FR",
    NL: "nl-NL",
    ES: "es-ES",
    AT: "de-DE",
    PL: "pl-PL",
    DK: "da-DK",
    SE: "sv-SE",
    IE: "en-US",
    IT: "it-IT",
    FI: "fi-FI",
    RU: "ru-RU",
    GR: "en-US",
    BE: "fr-FR",
    AL: "en-US",
    LU: "fr-FR",
    NO: "no-NO",
    AE: "ar-AE",
    IL: "ar-AE",
    KZ: "en-US",
    PT: "en-US",
    SA: "ar-AE",
    IR: "en-US",
    CA: "en-US",
    MX: "es-MX",
    BM: "en-US",
    CZ: "cs-CZ",
    HU: "en-US",
    BG: "en-US",
    ZA: "en-US",
    SI: "en-US",
    RO: "en-US",
    SK: "en-US",
    HR: "en-US",
    DJ: "ar-AE",
    SY: "ar-AE",
    UA: "en-US",
    KW: "ar-AE",
    BH: "ar-AE",
    LB: "ar-AE",
    QA: "ar-AE",
    OM: "ar-AE",
    JO: "ar-AE",
    PK: "en-US",
    IQ: "ar-AE",
    TR: "en-US",
    GE: "en-US",
    BR: "pt-BR",
    AZ: "en-US",
    BI: "en-US",
    ZM: "en-US",
    ZW: "en-US",
    CD: "fr-FR",
    AO: "en-US",
    PS: "ar-AE",
    LT: "en-US",
    RS: "en-US",
    NG: "fr-FR",
    IS: "en-US",
    MD: "en-US",
    MK: "en-US",
    CG: "fr-FR",
    LI: "de-DE",
    JE: "en-US",
    SC: "en-US",
    BA: "en-US",
    PY: "es-MX",
    EE: "en-US",
    LV: "en-US",
    KG: "en-US",
    IM: "en-US",
    BS: "en-US",
    GG: "en-US",
    MT: "en-US",
    LY: "ar-AE",
    AM: "en-US",
    VG: "en-US",
    YE: "ar-AE",
    BY: "en-US",
    AD: "fr-FR",
    AF: "en-US",
    AG: "en-US",
    AI: "en-US",
    AQ: "en-US",
    AR: "es-MX",
    AS: "en-US",
    AW: "en-US",
    AX: "fi-FI",
    BB: "en-US",
    BD: "en-US",
    BF: "fr-FR",
    BJ: "fr-FR",
    BL: "fr-FR",
    BN: "en-US",
    BO: "es-MX",
    BQ: "nl-NL",
    BT: "en-US",
    BV: "no-NO",
    BW: "en-US",
    BZ: "en-US",
    CC: "en-US",
    CF: "fr-FR",
    CI: "fr-FR",
    CK: "en-US",
    CL: "es-MX",
    CM: "fr-FR",
    CO: "es-MX",
    CR: "es-MX",
    CU: "es-MX",
    CV: "en-US",
    CW: "nl-NL",
    CX: "en-US",
    CY: "en-US",
    DM: "en-US",
    DO: "es-MX",
    DZ: "fr-FR",
    EC: "es-MX",
    EG: "ar-AE",
    EH: "ar-AE",
    ER: "ar-AE",
    ET: "en-US",
    FJ: "en-US",
    FK: "en-US",
    FM: "en-US",
    FO: "da-DK",
    GA: "fr-FR",
    GD: "en-US",
    GF: "fr-FR",
    GH: "en-US",
    GI: "en-US",
    GL: "da-DK",
    GM: "ar-AE",
    GN: "fr-FR",
    GP: "fr-FR",
    GQ: "es-MX",
    GS: "en-US",
    GT: "es-MX",
    GU: "en-US",
    GW: "en-US",
    GY: "en-US",
    HM: "en-US",
    HN: "es-MX",
    HT: "en-US",
    ID: "en-US",
    IO: "en-US",
    JM: "en-US",
    KE: "en-US",
    KH: "en-US",
    KI: "en-US",
    KM: "ar-AE",
    KN: "en-US",
    KP: "ko-KR",
    KY: "en-US",
    LA: "en-US",
    LC: "en-US",
    LK: "en-US",
    LR: "en-US",
    LS: "en-US",
    MA: "ar-AE",
    MC: "fr-FR",
    ME: "en-US",
    MF: "fr-FR",
    MG: "fr-FR",
    MH: "en-US",
    ML: "fr-FR",
    MM: "en-US",
    MN: "en-US",
    MO: "en-US",
    MP: "en-US",
    MQ: "fr-FR",
    MR: "fr-FR",
    MS: "en-US",
    MU: "en-US",
    MV: "en-US",
    MW: "en-US",
    MZ: "en-US",
    NA: "en-US",
    NC: "fr-FR",
    NE: "en-US",
    NF: "en-US",
    NI: "es-MX",
    NP: "en-US",
    NR: "en-US",
    NU: "en-US",
    NZ: "en-US",
    PA: "es-MX",
    PE: "es-MX",
    PF: "fr-FR",
    PG: "fr-FR",
    PM: "fr-FR",
    PN: "en-US",
    PR: "es-MX",
    PW: "en-US",
    RE: "fr-FR",
    RW: "en-US",
    SB: "en-US",
    SD: "en-US",
    SG: "en-US",
    SH: "en-US",
    SJ: "no-NO",
    SL: "en-US",
    SM: "it-IT",
    SN: "fr-FR",
    SO: "ar-AE",
    SR: "en-US",
    SS: "ar-AE",
    ST: "en-US",
    SV: "es-MX",
    SX: "nl-NL",
    SZ: "en-US",
    TC: "en-US",
    TD: "ar-AE",
    TF: "fr-FR",
    TG: "fr-FR",
    TJ: "ru-RU",
    TK: "en-US",
    TL: "en-US",
    TM: "ru-RU",
    TN: "fr-FR",
    TO: "en-US",
    TT: "en-US",
    TV: "en-US",
    TZ: "en-US",
    UG: "en-US",
    UM: "en-US",
    UY: "es-MX",
    UZ: "en-US",
    VA: "it-IT",
    VC: "en-US",
    VE: "es-MX",
    VI: "en-US",
    VU: "en-US",
    WF: "fr-FR",
    WS: "en-US",
    YT: "fr-FR",
};
export default Locales;
